import { createContext, useState } from "react";
import { SearchVehicleByParamsFullContextType } from "./types";
import { CarCatalogOptionsItem } from "@/types/Car/CarCatalogOptionsItem.interface";
import { Vehicle, CatalogData } from "./components/SearchVehicleByParamsContainer.d";

/** Контекст для данных поиска автомобиля */
export const SearchVehicleByParamsDataContext = createContext<SearchVehicleByParamsFullContextType | null>(null);

/** Провайдер для данных поиска автомобиля по параметрам */
export const SearchVehicleByParamsDataProvider = ({ children }: { children: React.ReactNode }) => {
    const [brands, setBrands] = useState<CarCatalogOptionsItem[]>([]);
    const [brand, setBrand] = useState<string>('');
    const [catalogInfo, setCatalogInfo] = useState<CatalogData[]>([]);
    const [vehicles, setVehicles] = useState<Vehicle[]>([]);
    const [vehicle, setVehicle] = useState<Vehicle>({} as Vehicle);
    const [vehicleId, setVehicleId] = useState<string>('');
    const [vehicleSsd, setVehicleSsd] = useState<string>('');
    const [catalogSsd, setCatalogSsd] = useState<string>('');
    const [showVehicles, setShowVehicles] = useState<boolean>(true);
    const [showCatalogInfo, setShowCatalogInfo] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    
    return (
        <SearchVehicleByParamsDataContext.Provider value={{ 
            brands, 
            brand, 
            catalogInfo, 
            vehicles, 
            vehicle, 
            vehicleId, 
            vehicleSsd, 
            catalogSsd, 
            showVehicles, 
            showCatalogInfo, 
            setShowVehicles, 
            setShowCatalogInfo, 
            isLoading, 
            error, 
            setBrands, 
            setBrand, 
            setCatalogInfo, 
            setVehicles, 
            setVehicle, 
            setVehicleId, 
            setVehicleSsd, 
            setCatalogSsd, 
            setIsLoading, 
            setError 
        }}>
            {children}
        </SearchVehicleByParamsDataContext.Provider>
    );
};